import { IconButton, SvgIcon } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import CoauthorIconSvg from '../../../../vectors/coauthor-logo.svg';

export const CoauthorIcon = (props) => <SvgIcon component={CoauthorIconSvg} inheritViewBox {...props} />

const CoauthorIconButton = styled(({ size, ...props }) => {
  const viewBox = size === 'large' ? '-2 -1 18 18' : '-4 -3 22 22';
  return (
    <IconButton aria-label="open co-author" disableRipple {...props}>
      <CoauthorIcon viewBox={viewBox} />
    </IconButton>
  );
})(({ size }) => ({
  borderRadius: '50%',
  '&:active, &:hover, *:has(div[role="dialog"][aria-label="Co-Author"]) > &': {
    background: 'linear-gradient(225deg, rgba(63, 215, 255, 0.25) 0%, rgba(8, 149, 220, 0.25) 30.68%, rgba(103, 89, 255, 0.25) 62.53%, rgba(153, 51, 255, 0.25) 100%)',
  },
  width: size === 'large' ? 40 : 28,
  height: size === 'large' ? 40 : 28,
}))

const CoauthorTextButton = styled(({ children, ...props }) => (
  <button {...props}>
    <div className="label">
      <CoauthorIcon viewBox="0 -4 24 24" />
      {children}
    </div>
  </button>
))({
  border: 'none',
  background: 'transparent',
  borderRadius: 6,
  '&:active, &:hover, *:has(div[role="dialog"][aria-label="Co-Author"]) > &': {
    background: 'linear-gradient(225deg, rgba(63, 215, 255, 0.15) 0%, rgba(8, 149, 220, 0.15) 30.68%, rgba(103, 89, 255, 0.15) 62.53%, rgba(153, 51, 255, 0.15) 100%)',
  },
  '& .label': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    background: 'linear-gradient(225deg, #33B4D7 0%, #107BBF 30.68%, #594CD9 62.53%, #802ED9 100%)',
    backgroundClip: 'text',
    backgroundSize: '100%',
    backgroundRepeat: 'repeat',
    textTransform: 'none',
    fontWeight: 'bold',
    '-webkit-background-clip': 'text', // Use the text as a mask for the background.
    '-moz-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
    '-moz-text-fill-color': 'transparent',
  }
})

const CoauthorButton = styled(({
  children,
  variant = 'text',
  ...props
}) => {
  const { t } = useTranslation();
  if (!wbConfig.coauthorEnabled) return null;
  switch (variant) {
    case 'text':
      return <CoauthorTextButton {...props}>{children ?? t('Use Co-Author')}</CoauthorTextButton>;
    case 'icon':
      return <CoauthorIconButton {...props} />;
    default:
      console.error('Unknown variant:', variant);
      return null;
  }
})({})

export default CoauthorButton;